import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

export class DealSwap {
  constructor(form, currencyNormalize = {}, tradingAccountPrimeBrokerNormalize = {}) {
    this.deal_type = form.deal_type.name
    this.client_side = form.client_side
    this.client_price = Number(form.client_price)
    this.market_maker_price = Number(form.market_maker_price)
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.client = form.client
    this.market_maker = form.market_maker
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.quantity = Number(form.quantity)
    this.client_value_date = form.client_value_date
      ? dayjs(form.client_value_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.market_maker_value_date = form.client_value_date
      ? dayjs(form.client_value_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.client_far_price = Number(form.client_far_price)
    this.market_maker_far_price = Number(form.market_maker_far_price)
    this.client_far_value_date = form.client_far_value_date
      ? dayjs(form.client_far_value_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.market_maker_far_value_date = form.client_far_value_date
      ? dayjs(form.client_far_value_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.far_leg_quantity = Number(form.far_leg_quantity)
    if (
      this.base_currency.length === 3 &&
      this.counter_currency.length === 3 &&
      currencyNormalize.data &&
      (currencyNormalize?.data[this.base_currency]?.is_ndf ||
        currencyNormalize?.data[this.counter_currency]?.is_ndf)
    ) {
      this.far_fixing_date = form.far_fixing_date
        ? dayjs(form.far_fixing_date).format(DATE_FORMAT.REGULAR_DATE)
        : ''
      this.fixing_date = form.fixing_date
        ? dayjs(form.fixing_date).format(DATE_FORMAT.REGULAR_DATE)
        : ''
      this.fixing_source = form.fixing_source
    }
    this.client_note = form.client_note
    this.market_maker_note = form.market_maker_note
    if (
      this.client &&
      this.market_maker &&
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker?.[this.client]
        ?.prime_broker === 'RBS' &&
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker?.[this.market_maker]
        ?.prime_broker === 'RBS'
    ) {
      this.bdr = form.bdr
      this.is_pba = form.is_pba
    }
    this.trade_origin = 'FXER'
  }
}
